var _defs, _path, _path2, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpackNew211({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M5.32,3.92h1V9.33c0,2.15-1.05,2.81-2.44,2.81A3.58,3.58,0,0,1,2.8,12L3,11.09a2.29,2.29,0,0,0,.87.16c.94,0,1.49-.42,1.49-2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M8.1,4A9.84,9.84,0,0,1,10,3.86a3.33,3.33,0,0,1,2.22.59,1.69,1.69,0,0,1,.67,1.43,1.9,1.9,0,0,1-1.37,1.77v0a2.07,2.07,0,0,1,1.67,2,2.19,2.19,0,0,1-.68,1.62,4.06,4.06,0,0,1-2.8.76A11.75,11.75,0,0,1,8.1,12ZM9.15,7.34h.94c1.11,0,1.75-.58,1.75-1.35,0-1-.71-1.32-1.77-1.32a4.14,4.14,0,0,0-.92.07Zm0,3.87a5,5,0,0,0,.87,0c1.08,0,2.08-.39,2.08-1.57S11.15,8.13,10,8.13H9.15Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 1.01,
    y: 1.01,
    width: 13.99,
    height: 13.99
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpackNew211);
export default __webpack_public_path__ + "static/media/Symbolpack_New_211.5e6c998fb811d12ab2b356f45e33838b.svg";
export { ForwardRef as ReactComponent };